import React from "react";
import * as urls from "./InSilicoPredictionsUrls";
import {
  renderPredictions,
  renderMultipleCommasWithDescription,
} from "./InSilicoPredictionsHelpers";
import HelperText from "../../../../components/atoms/HelperText";

export const displayAloft = (dbnsfp, dbnsfpVersion, schema) => {
  return (
    (dbnsfp.aloft_pred ||
      dbnsfp.aloft_fraction_transcripts_affected ||
      dbnsfp.aloft_prob_tolerant ||
      dbnsfp.aloft_prob_recessive ||
      dbnsfp.aloft_prob_dominant) && (
      <tr key="aloft" className="dbnsfp-row">
        <td width="20%">
          <a href={urls.aloftUrl} target="_blank">
            {"ALoFT "}
          </a>
          <HelperText fieldDescriptionKey="ALoFT" />
          <br />
          {dbnsfpVersion}
        </td>
        {renderPredictions(
          dbnsfp,
          "aloft_pred",
          schema.dbnsfp.items.properties.aloft_pred.label,
          null
        )}
        {renderMultipleCommasWithDescription(
          dbnsfp,
          "aloft_confidence",
          schema.dbnsfp.items.properties.aloft_confidence.label,
          true
        )}
        {renderMultipleCommasWithDescription(
          dbnsfp,
          "aloft_fraction_transcripts_affected",
          schema.dbnsfp.items.properties.aloft_fraction_transcripts_affected
            .label,
          true
        )}
        {renderMultipleCommasWithDescription(
          dbnsfp,
          "aloft_prob_tolerant",
          schema.dbnsfp.items.properties.aloft_prob_tolerant.label,
          true
        )}
        {renderMultipleCommasWithDescription(
          dbnsfp,
          "aloft_prob_recessive",
          schema.dbnsfp.items.properties.aloft_prob_recessive.label,
          true
        )}
        {renderMultipleCommasWithDescription(
          dbnsfp,
          "aloft_prob_dominant",
          schema.dbnsfp.items.properties.aloft_prob_dominant.label,
          true
        )}
      </tr>
    )
  );
};
